import React, { useEffect } from 'react'
import Messages from '../../modules/Messages/Messages'
import "./home.css"
import { SelectedUserContextProvider } from '../../context/selectedUserContext'
const Home = () => {
    const serverTest = async () => {
        const res = await fetch("/")
        const body = await res.text();
        console.log(body);
    }
    useEffect(() => {
        serverTest()
    }, [])
    return (
        <React.Fragment >
            <SelectedUserContextProvider>
                <Messages />
            </SelectedUserContextProvider>



        </React.Fragment>
    )
}

export default Home
